import type { DisposeRegistry } from "./DisposeRegistry";
import type { ClickVoiceLike, ToneAdapter } from "./tone";

/**
 * The only sound source in Phase 0.
 *
 * It exists to prove the whole path — BarPlanner -> PendingQueue ->
 * RollingDispatcher -> MasterBus -> Limiter -> Destination — actually works,
 * before any generator exists. Phase 1 keeps it as a debug tool (default off).
 *
 * Created once at init; never allocated per note, so the node count stays flat.
 */
export class DiagnosticClick {
  private readonly voice: ClickVoiceLike;
  private active = 0;

  constructor(tone: ToneAdapter, disposeRegistry: DisposeRegistry) {
    this.voice = disposeRegistry.register(tone.createClickVoice());
  }

  trigger(midi: number | null, durationSec: number, timeSec: number, velocity: number): void {
    this.active += 1;
    this.voice.trigger(midi, durationSec, timeSec, velocity);
    // The envelope is ~70ms; treat the voice as free again shortly after.
    // Counting rather than tracking exact envelope state is enough for diagnostics.
    if (this.active > 1) this.active = 1;
  }

  releaseAll(): void {
    this.voice.releaseAll();
    this.active = 0;
  }

  get activeVoiceCount(): number {
    return this.active;
  }
}
